import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Reader from "@/pages/Reader";
import Admin from "@/pages/Admin";
import Print from "@/pages/Print";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/read" element={<Navigate to="/read/en" replace />} />
          <Route path="/read/:lang" element={<Reader />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/print/:lang" element={<Print />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
